import React, { useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Alert } from "../Alert";
import { ModalComp } from "../ModalComp";
import { useTranslation } from "react-i18next";
import { AutomationZones } from "./AutomationZones";
import { automationAddWidget } from "../../api";
import { FiZap, FiChevronDown, FiChevronUp, FiClock, FiX } from "react-icons/fi";

const AutomationAdd = ({
  titleEdit,
  iconEdit,
  uid,
  submit,
  setOpenAddAutomationModal,
  closeModal,
  props,
  scenarioCommandEdit,
  setScenarioCommandEdit,
}) => {
  const [idd, setIdd] = useState("");
  const token = Cookies.get("token");
  const [title, setTitle] = useState(titleEdit || "");
  const [widgetIndex, setWidgetIndex] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const { t } = useTranslation();
  const [automationCommand, setAutomationCommand] = useState([]);
  const [automationCommandCopy, setAutomationCommandCopy] = useState(automationCommand);
  const [isIconDropdownOpen, setIsIconDropdownOpen] = useState(false);

  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
      question: false,
    }));
  };

  const handleTitle = (e) => {
    setTitle(e.target.value);
  };

  const icons = [
    { name: "خواب", icon: "icon-slepp", value: "icon-slepp" },
    { name: "موسیقی", icon: "icon-muic", value: "icon-muic" },
    { name: "داخل خانه", icon: "icon-in", value: "icon-in" },
    { name: "بیرون خانه", icon: "icon-out", value: "icon-out" },
    { name: "آفتاب", icon: "icon-sun", value: "icon-sun" },
    { name: "تلویزیون", icon: "icon-tvv", value: "icon-tvv" },
  ];
  
  const [icon, setIcon] = useState(iconEdit || "icon-muic");
  
  const handleIcon = (i) => {
    setIcon(i);
    setIsIconDropdownOpen(false);
  };

  const widgetClicked = (value, index) => {
    setWidgetIndex(index);
  };

  const handleClose = (i) => {
    const close = automationCommand.filter(
      (index) => index.caption.caption !== i
    );
    setAutomationCommand(close);
  };

  const [openAutomationZoneModal, setOpenAutomationZoneModal] = useState(false);

  const toggleAutomationZone = () => {
    setOpenAutomationZoneModal(!openAutomationZoneModal);
  };

  const handleShowEvents = () => {
    if (title) {
      setOpenAutomationZoneModal(true);
    } else {
      setShowAlert({
        show: true,
        message: t("لطفا یک نام برای اتوماسیون خود انتخاب نمایید"),
        type: "Warning",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 5000);
    }
  };

  return (
    <>
      <ModalComp
        modal={openAutomationZoneModal}
        toggle={toggleAutomationZone}
        component={
          <AutomationZones
            title={title}
            icon={icon}
            setAutomationCommand={setAutomationCommand}
          />
        }
      />

      <div className="automation-add-container">
        {/* Header */}
        <div className="automation-add-header">
          <div className="automation-add-icon">
            <FiZap size={22} />
          </div>
          <h3 className="automation-add-title">{t("افزودن اتوماسیون جدید")}</h3>
        </div>

        <p className="automation-add-description">
          {t("نام و آیکون دلخواه خود را برای اتوماسیون انتخاب نمایید")}
        </p>

        {/* Name & Icon Section */}
        <div className="automation-name-section">
          <div className="automation-input-wrapper">
            <input
              className="automation-input"
              type="text"
              placeholder={t("نام اتوماسیون...")}
              onChange={handleTitle}
              value={title}
            />
          </div>
          
          {/* Icon Dropdown */}
          <div className="automation-icon-dropdown">
            <button
              className="automation-icon-btn"
              onClick={() => setIsIconDropdownOpen(!isIconDropdownOpen)}
            >
              <i className={icon}></i>
              {isIconDropdownOpen ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
            </button>
            {isIconDropdownOpen && (
              <div className="automation-icon-menu">
                <div className="automation-icons-list">
                  {icons.map((item, idx) => (
                    <div
                      key={idx}
                      className={`automation-icon-option ${icon === item.icon ? "active" : ""}`}
                      onClick={() => handleIcon(item.icon)}
                    >
                      <i className={item.icon}></i>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Selected Events Section */}
        {automationCommand.length > 0 && (
          <div className="automation-events-section">
            <div className="automation-events-header">
              <FiZap size={14} />
              <span className="automation-events-title">{t("رویدادهای انتخاب شده")}</span>
              <span className="automation-events-count">{automationCommand.length}</span>
            </div>
            <div className="automation-events-list">
              {automationCommand.map((item, index) => {
                const isActive = widgetIndex === index;
                return (
                  <div
                    key={index}
                    className={`automation-event-item ${isActive ? "active" : ""}`}
                    onClick={() => widgetClicked(item, index)}
                  >
                    <div className="automation-event-info">
                      <span className="automation-event-name">
                        {item.caption?.caption || "---"}
                      </span>
                      <span className={`automation-event-command ${item.command?.command === "10" ? "on" : "off"}`}>
                        {item.command?.command === "10" ? t("روشن") : t("خاموش")}
                      </span>
                    </div>
                    <button
                      className="automation-event-delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClose(item.caption?.caption);
                      }}
                    >
                      <FiX size={14} />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Coming Soon Section - Red Rectangle */}
        <div className="automation-coming-soon">
          <div className="automation-coming-soon-icon">
            <FiClock size={28} />
          </div>
          <h4 className="automation-coming-soon-title">{t("به زودی...")}</h4>
          <p className="automation-coming-soon-description">
            {t("بخش تنظیمات شرط و زمان‌بندی اتوماسیون به زودی اضافه خواهد شد")}
          </p>
          <div className="automation-coming-soon-badge">
            {t("در حال توسعه")}
          </div>
        </div>
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
          setOpenAddAutomationModal={setOpenAddAutomationModal}
          setIdd={setIdd}
        />
      )}
    </>
  );
};

export { AutomationAdd };